import { render, staticRenderFns } from "./HistoricoPepMicro.vue?vue&type=template&id=4d62806e&scoped=true&"
import script from "./HistoricoPepMicro.vue?vue&type=script&lang=js&"
export * from "./HistoricoPepMicro.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoPepMicro.vue?vue&type=style&index=0&id=4d62806e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d62806e",
  null
  
)

export default component.exports